export default class VisualTemplate {

    constructor() {
        this.horizontalBanner = [];
        this.verticalBanner = [];
        this.bannerInterval = 0;

        this.horizontalLibraryInfoImages = [];
        this.verticalLibraryInfoImages = [];

        this.showExitButton = false;
        this.showIndexButton = false;
        this.showPageSlider = false;
        this.showBookmarksButton = false;
        this.showCatalogMenu = false;
        this.showShareButton = false;
        this.showSearchButton = false;
        this.showChangeLanguageButton = false;

        this.toolbarTintColor = '';
        this.toolbarTintSecondaryColor = '';
        this.toolbarBackgroundColor = '';
        this.listCatalogsBackgroundColor = '';
        this.catalogTitleColor = '';
        this.catalogDescriptionColor = '';
        this.catalogButtonColor = '';
        this.separatorLineColor = '';
    }

}